import L from "leaflet";

export const markerProperties = {
    garrison: {
        friendly: {
            radius: 200,
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/garrison_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            radius: 200,
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/garrison_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    outpost: {
        friendly: {
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/outpost_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/outpost_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    supplies: {
        friendly: {
            radius: 50,
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/marker.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            radius: 50,
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/marker.svg",
                iconSize: [32, 32],
            }),
        },
    },
    supply_drop: {
        friendly: {
            radius: 50,
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/supply_drop_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            radius: 50,
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/supply_drop_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    tank_recon: {
        friendly: {
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_recon_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_recon_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    tank_light: {
        friendly: {
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_light_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_light_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    tank_medium: {
        friendly: {
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_medium_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_medium_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
    tank_heavy: {
        friendly: {
            color: "#008000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_heavy_friendly.svg",
                iconSize: [32, 32],
            }),
        },
        enemy: {
            color: "#FF0000",
            icon: new L.Icon({
                iconUrl: "/icons/markers/tank_heavy_enemy.svg",
                iconSize: [32, 32],
            }),
        },
    },
};
